module.exports = __webpack_public_path__ + "img/czb.b093bf1a.jpg";